<template>
    <div class="home-page">
		<Header></Header>
		<div class="list" v-if="!notFound">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
				<span class="">{{$t('Content_List')}}</span>
			</div>
			<div class="section-list">
				<div class="section-content">
					<div class="content-list" @click="toContentDetail(item.knowledge_id)"  v-for="(item,index) in list">
						<p class="title fs50 text-overflow2">{{item.info}}</p>
						<div class="content-desc mt30 flex">
							<img :src="item.images" />
							<div class="descent" v-html="item.content"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt100 ac more" @click="getMore" v-if="list!=''">
				<img src="static/images/next2.png" />
			</div>
		</div>	
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {
		
        return {
			notFound:false,
			list:[],
			page_id:1,
			page_size:10
			
		}
    },
	watch: {
		
	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome()
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		toContentDetail(id){
			this.$router.push({path:'/contentDetail',query: {id:id}})
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let url = '/user/content'+'&page_id='+that.page_id+'&page_size=10'
			let data = {'token':localStorage.getItem('token'),uuid:localStorage.getItem('uuid'),'page_id':that.page_id,'page_size':that.page_size}
			that.$api.post(url,data,r =>{
				that.$parent.returnCode(r,function(){
					that.$parent.loadModal(false);
					that.list = that.list.concat(r.data.list)
					if(r.data.list.length<=0){
						that.$utils.alertText(that.$t('no_data'),80);
						return;
					}					
                });
				
			})
		},
		getMore(){
			let that = this;
			that.page_id++
			that.getHome();
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/contentList.vue